import styled from "@emotion/styled"
import Button from "components/Buttons/Button"

const HeroFormFinalBtn = styled(Button)``

export default HeroFormFinalBtn
